import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from '@/modules/auth/ui/AuthProvider';
import { queryKeys } from './queryKeys';

export function useApps() {
  const { authFetch } = useAuthContext();

  return useQuery({
    queryKey: queryKeys.apps.all,
    queryFn: async () => {
      const response = await authFetch('/api/apps');
      if (!response.ok) throw new Error('Failed to load apps');
      return response.json();
    },
  });
}

export function useApp(appId) {
  const { authFetch } = useAuthContext();

  return useQuery({
    queryKey: queryKeys.apps.detail(appId),
    queryFn: async () => {
      const response = await authFetch(`/api/apps/get?id=${appId}`);
      if (!response.ok) throw new Error('Failed to load app');
      return response.json();
    },
    enabled: !!appId,
  });
}

export function useBuildQueue() {
  const { authFetch } = useAuthContext();

  return useQuery({
    queryKey: queryKeys.apps.queue,
    queryFn: async () => {
      const response = await authFetch('/api/build-requests/queue');
      if (!response.ok) throw new Error('Failed to load build queue');
      return response.json();
    },
  });
}

export function useAppSummary() {
  const { authFetch } = useAuthContext();

  return useQuery({
    queryKey: queryKeys.apps.summary,
    queryFn: async () => {
      const response = await authFetch('/api/apps/summary');
      if (!response.ok) throw new Error('Failed to load app summary');
      return response.json();
    },
  });
}

export function useBuildRequest(appId) {
  const { authFetch } = useAuthContext();

  return useQuery({
    queryKey: ['buildRequest', appId],
    queryFn: async () => {
      const response = await authFetch(`/api/build-requests/get?id=${appId}`);
      if (!response.ok) throw new Error('Failed to load quote details');
      return response.json();
    },
    enabled: !!appId,
  });
}
